import './TermsAndConditionsCheckbox.scss';

import { Checkbox } from '@boi/core/lib';
import PropTypes from 'prop-types';
import React from 'react';

import {
  commissionStatementSummaryUrl,
  dataPrivacyHomeUrl, homeAccessibilityUrl,
  policyImportantDocuments,
  termsOfBusinessUrl,
  termsOfUseUrl
} from '../../../constants/externalLinks';
import { GET_HOME_DOCUMENT, REQUIRED_DOCUMENTS } from '../../../constants/home';
import { commonFormStylesIdentifier } from '../../../constants/styleConstants';
import { getObjectFromSessionStorage } from '../../../helpers';
import { getDownloadLink } from '../../../utils/utils';
import { ExternalLink } from '../../ExternalLink/ExternalLink';

const TermsAndConditionsCheckbox = ({
  setFieldValue,
  values,
  showStatementOfFact = false
}) => {
  const className = 'c-TermsAndConditionsCheckbox';

  const getUrl = e => {
    const reqDocs = getObjectFromSessionStorage(REQUIRED_DOCUMENTS);
    if (reqDocs.statement_of_fact) {
      return getDownloadLink(
        e,
        reqDocs?.statement_of_fact?.document_id,
        reqDocs?.statement_of_fact?.display_name,
        GET_HOME_DOCUMENT
      );
    }
  };

  return (
    <div className={className}>
      <div className={`${className}__title`}><h4>Terms and Conditions</h4></div>
      <div>
        You are under a duty to answer all the questions that have been asked,
        honestly and with reasonable care and attention. These questions are
        material in determining if the insurance underwriters can accept this
        risk, what terms are applied and what premium is charged. Failure to do
        so could result in the insurance underwriters cancelling the contract,
        rejecting a claim, or limiting the claim payment. See your Policy
        documentation for full details of cover{' '}
        {showStatementOfFact ? (
          <ExternalLink url="#" text="here." onClick={getUrl}
                        linkAriaLabel={"External link to Statement of fact document, downloads document"}/>
        ) : (
          <ExternalLink text="here." url={policyImportantDocuments}
                        linkAriaLabel={"External link important documents page"}/>
        )}
      </div>
      <div className={`${commonFormStylesIdentifier}__checkboxContainer`}>
        <Checkbox
          id="acceptedTermsAndConditions"
          name="acceptedTermsAndConditions"
          label={
            <>
              Please tick to confirm that you understand the above information
              and to confirm your acceptance of Bank of Ireland Insurance
              Services{' '}
              <ExternalLink text="Terms of Business" url={termsOfBusinessUrl}
                            linkAriaLabel={"External link to Terms of Business document, downloads document"}/>
              {', '}
              <ExternalLink
                text="Commission Summary Document"
                url={commissionStatementSummaryUrl}
                linkAriaLabel={"External link to Commission Summary Document, downloads document"}
              />
              {', '}
              <ExternalLink text="Terms of Use" url={termsOfUseUrl}
                            linkAriaLabel={"External link to Terms of Use document, downloads document"}/>
              {', '}
              <ExternalLink
                text="Data Privacy Notice"
                url={dataPrivacyHomeUrl}
                linkAriaLabel={"External link to Data Privacy Notice document, downloads document"}
              />
              {' and '}
              <ExternalLink
                url={homeAccessibilityUrl}
                text={"Bank of Ireland Accessibility Statement"}
                linkAriaLabel={"External link to Bank of Ireland Accessibility Statement document, downloads document"}
              />
              {' before proceeding.'}
            </>
          }
          isChecked={values.acceptedTermsAndConditions}
          onChange={() =>
            setFieldValue(
              'acceptedTermsAndConditions',
              !values.acceptedTermsAndConditions
            )
          }
          value={values.acceptedTermsAndConditions}
        />
      </div>
    </div>
  );
};

TermsAndConditionsCheckbox.propTypes = {
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  showStatementOfFact: PropTypes.bool
};

export default TermsAndConditionsCheckbox;
